import ClickableElement from './ClickableElement';

export default ClickableElement;



// WEBPACK FOOTER //
// ./src/components/ClickableElement/index.ts